<template>
  <div class="pdf-report-residents">
    <NavBar class="nav--bar" />

    <AuthBySessionExpired class="auth--by--session--expired" />

    <div class="container">
      <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
        <div class="container">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0">
              <label class="m-0">Contratos vencendo nos próximos:</label>

              <select v-model="daysOfContractTermination" class="form-control">
                <option disabled selected>Selecione o intervalo</option>
                <option value="10">10 dias</option>
                <option value="20">20 dias</option>
                <option value="30">30 dias</option>
                <option value="60">60 dias</option>
                <option value="90">90 dias</option>
              </select>

              <small class="text-muted"
                >Filtre os clientes conforme a proximidade do vencimento do
                contrato.</small
              >
            </div>

            <div class="col-md-12 pt-0 pb-0">
              <ErrorsMessages :errors="errors" />
            </div>

            <div class="col-md-12 text-right">
              <v-btn
                :disabled="loading"
                @click="paginate()"
                class="btn-filter"
                type="relief"
                ><i class="fas fa-filter mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "FILTRAR" }}
              </v-btn>
            </div>
          </div>
        </div>
      </b-modal>

      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>

        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
          <h3 class="title-pages pt-1">RELATÓRIO: TÉRMINO DE CONTRATO</h3>
        </div>

        <div
          class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>

          <v-btn
            :disabled="data.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>

        <div class="table-responsive" v-show="data.length > 0">
          <div class="pdf-report-residents">
            <table
              class="table-always"
              v-for="(resident, residentKey) in data"
              :key="residentKey"
            >
              <thead>
                <tr>
                  <th>
                    <div class="header-space">
                      <div class="row">
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                          <img
                            v-if="user.logo_url"
                            class="rest_home_logo_url"
                            :src="user.logo_url"
                          />
                          <div v-if="!user.logo_url" class="ml-1">
                            <strong class="text-uppercase">{{
                              rest_home_name
                            }}</strong>
                          </div>
                        </div>
                        <div
                          class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                        >
                          <img
                            v-if="resident.photo_url"
                            class="resident_photo_url"
                            :src="resident.photo_url"
                          />
                          <img
                            v-if="!resident.photo_url"
                            class="resident_photo_url"
                            :src="require('../../assets/user.png')"
                          />
                          <div class="ml-5">
                            <h6 class="mb-0">
                              {{ resident.name }}
                            </h6>
                            <h6 class="mb-0 worksansr upper-text">
                              Data de nascimento:
                              {{ formatDate(resident.date_of_birth, false) }}
                              -
                              {{ getAge(resident.date_of_birth) }}
                              anos
                            </h6>
                            <h6 class="mb-0 worksansr upper-text">
                              Data de admissão:
                              {{
                                formatDate(resident.date_of_reception, false)
                              }}
                            </h6>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                        >
                          <img
                            class="logo"
                            src="https://sistemclinupload.s3.amazonaws.com/logo.png"
                            width="180"
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <div class="content">
                      <div class="row data-inside-avoid">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
                        >
                          <h6 class="mb-0">INFORMAÇÕES</h6>
                        </div>
                        <div
                          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
                        >
                          <strong>DATA DO TÉRMINO DO CONTRATO:</strong>
                          {{ formatDate(resident.date_end_contract, false) }}
                        </div>
                      </div>
                      <hr class="m-0" />
                    </div>

                    <div class="footer text-center">
                      <hr class="mb-1 border-black" />
                      <h6 class="mb-0 worksansr">
                        (Assinatura eletrônica)
                        <strong>
                          {{
                            professionalClassCouncilValue({
                              id: user.professional_class_council_id,
                              name: user.name,
                              profile: user.profile_name,
                              cpf: user.cpf,
                              office: user.office,
                              value: user.professional_class_council_value,
                            })
                          }}
                          <span class="ml-1">
                            - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                          </span>
                        </strong>
                      </h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import ErrorsMessages from "../Components/ErrorsMessages";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import routes from "../../routes";

import { getAge } from "../../lib/getAgeByDate";

import { userData } from "../../lib/functions";

import api from "../../services/api";

import moment from "moment";

export default {
  name: "ReportsTerminationContract",

  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
  },

  data() {
    return {
      loading: false,

      daysOfContractTermination: null,

      data: [],

      user: {},

      errors: [],
    };
  },

  mounted() {
    this.retrieve();
  },

  methods: {
    getAge,
    formatDate,
    moment,
    professionalClassCouncilValue,

    async retrieve() {
      const { user } = userData();

      this.user = user;

      this.$bvModal.show("filter");
    },

    async paginate() {
      try {
        this.loading = true;

        const { daysOfContractTermination } = this;

        var params = { daysOfContractTermination };

        const response = await api.get(
          "/rest-home/report/termination-contract",
          {
            params,
          }
        );

        const { data, error, errors } = response.data;

        if (error) {
          this.data = [];

          this.errors = errors;
        } else {
          this.errors = [];

          this.data = data;

          this.$bvModal.hide("filter");
        }

        // this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToPrint: () => window.print(),

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.pdf-report-residents p {
  font-weight: 100 !important;
}
.pdf-report-residents .text-amount {
  font-size: 13px;
}

.pdf-report-residents .date-amount {
  font-size: 13px;
}

.pdf-report-residents .header,
.pdf-report-residents .header-space {
  height: auto;
}

.pdf-report-residents .footer,
.pdf-report-residents .footer-space {
  height: 50px;
}

.pdf-report-residents .header {
  position: fixed;
  top: 0;
}

.pdf-report-residents .logo {
  width: 100%;
  height: 50px;
  object-fit: contain;
}

.pdf-report-residents .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-residents .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-residents .table-always,
.pdf-report-residents td,
.pdf-report-residents th {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-residents th {
  background-color: #f5f5f5;
}

.pdf-report-residents .medicine-name {
  font-size: 14px;
}

.pdf-report-residents small {
  font-size: 12px;
}

@media print {
  .pdf-report-residents .table-always {
    width: 100% !important;
    border: none !important;
  }

  .pdf-report-residents .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .pdf-report-residents .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-residents .content-movimentation {
    page-break-inside: avoid !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .pdf-report-residents .table-always {
    page-break-before: always !important;
  }

  .pdf-report-residents .header,
  .pdf-report-residents .header-space {
    height: auto;
  }

  body {
    margin: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-residents button {
    display: none;
  }

  .pdf-report-residents .nav--bar {
    display: none !important;
  }

  .pdf-report-residents .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-residents .content-filter {
    display: none;
  }

  .pdf-report-residents .data-inside-avoid {
    page-break-inside: avoid !important;
  }
}
</style>
